import { ChangeDetectorRef, Component } from "@angular/core";
import { ExcelExportParams, ExcelStyle, GridApi, GridOptions, SelectionChangedEvent , GridReadyEvent } from "ag-grid-community";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../../services";
import { LoadingScreenService } from "../../shared/loading-screen.service";
import { ApprovablePlansColumnDefinition } from "./ag-grid-column-definition";
import { PlanRegion } from "src/app/generated-models/PlanRegion";
import { PlanKindEnum, PlanRegionStatusEnum } from "src/app/shared/enums/plan-enums";
import { GridViewBaseComponent } from "../../utility/grid-view-base.component";
import { ColParams } from "src/app/shared/grid/ag-grid";
import { ModalService } from "../../shared/modal.service";
import { SharedDataService } from "../../services/sharedDataService";
import { getExportedExcelFileNameSuffix } from "src/app/utility/common-helper";
import { PlanRegionWithApprovalStatus } from "../../generated-models/PlanRegionWithApprovalStatus";

@Component({
  standalone: false,
  templateUrl: "./plans-approvable.component.html",
  styleUrls: ["../../styles.scss", "./plan.scss"],
})
export class PlansApprovableComponent extends GridViewBaseComponent {
  gridApi: GridApi;
  gridOptions: GridOptions;
  initPageSize: number = 15;
  showApproveableOnly: boolean = true;

  keyFilterStats = "filter:approve-regional-plans";
  rowData: PlanRegionWithApprovalStatus[] = [];
  headerStyle: ExcelStyle[] = [
    {
      id: "header",
      font: {
        bold: true,
      },
    },
  ];

  selectedRowCount = 0;
  loadCheckBox = false;
  hasRowSelected = false;

  constructor(
    protected apiService: ApiService,
    private loadingService: LoadingScreenService,
    private notificationService: ToastrService,
    protected sharedDataService: SharedDataService,
    protected modalService: ModalService,
    private cdr: ChangeDetectorRef
  ) {
    super(apiService, sharedDataService);
  }

  ngOnInit() {
    ApprovablePlansColumnDefinition.push({
      colId: "customFilter",
      headerName: "Custom Filter",
      valueGetter: () => {
        return true;
      },
      filterParams: {
        values: ["true", "false"],
        newRowsAction: "keep",
      },
      hide: true,
    });
    super.InitAgGrid(ApprovablePlansColumnDefinition);
  }

  onGridReady(params: GridReadyEvent): void {
    super.onGridReady(params);
    this.gridApi.setFilterModel({
      customFilter: { values: ["true"] },
    });
    setTimeout(() => {
      this.gridApi.autoSizeAllColumns();
    }, 100);
  }

  onShowApproveableOnlyChanged(): void {
    this.showApproveableOnly = false;
    this.refreshData();
  }

  refreshData() {
    this.selectedRowCount = 0;
    this.loadingService.setLoading(true);
    this.apiService.getApprovableRegionalPlans(this.showApproveableOnly).subscribe(
      (response) => {
        response.forEach((plan) => {
          if ((plan.Kind === null || plan.Kind === undefined) && plan.Blueprint && plan.Blueprint.includes("_")) {
            plan.Kind = PlanKindEnum.Growth;
          }
        });
        this.rowData = response;
        if (this.gridApi) {
          this.gridApi.setGridOption("rowData", this.rowData);
        }
        this.loadingService.setLoading(false);
        super.setupFilterByLocalData();
      },
      (e: any) => {
        this.rowData = [];
        this.loadingService.setLoading(false);
        this.notificationService.error(e);
      }
    );
    this.setActionCheckBoxAttributes();
    setTimeout(() => {
      this.gridApi.autoSizeAllColumns();
    }, 100);
    // this.apiService.getRegionList().subscribe(
    //   (regions) => {
    //     this.supportedRegions = regions.filter(r => r.ArmRegionName == 'qatarcentral');
    //     this.region = this.supportedRegions[0].ArmRegionName;
    //   }
    // );
  }

  async batchApprovePlan(formValues?: PlanRegion[]) {
    const selectedPlanRegion: PlanRegion[] = formValues ? formValues : this.gridApi.getSelectedRows();
    if (!selectedPlanRegion && selectedPlanRegion.length === 0) {
      this.message = "Please select Plan Region(s) to approve";
      this.notificationService.warning(this.message);
      return;
    }
    const needRefresh: boolean = await this.modalService.planBatchApprovalModal("Approve Plan Region(s)", selectedPlanRegion);
    if (needRefresh) {
      this.refreshData();
    }
  }

  onSelectionChanged() {
    this.selectedRowCount = this.gridApi.getSelectedNodes().length;
    this.hasRowSelected = this.selectedRowCount > 0;
    this.cdr.detectChanges();
  }

  async batchRemovePlans() {
    const selectedRows = this.gridApi.getSelectedRows() as PlanRegionWithApprovalStatus[];
    await this.modalService.planSetRemovedModal(selectedRows);
    this.refreshData();
    this.hasRowSelected = false;
  }

  showBatchApproval() {
    if (this.userProfile) {
      return this.userProfile.IsAdmin;
    }
    return false;
  }

  // setActionCheckBoxAttributes call only once by loadCheckBox flag
  setActionCheckBoxAttributes() {
    if (this.showBatchApproval() && ApprovablePlansColumnDefinition?.length && !this.loadCheckBox) {
      const columnDefs = [];
      this.gridOptions.columnDefs.map((map) => {
        if (map.headerName === "Action") {
          columnDefs.push({
            ...map,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
          });
        } else {
          columnDefs.push(map);
        }
      });

      this.gridApi.setGridOption('columnDefs', columnDefs);
      this.loadCheckBox = true;
    }
  }

  exportExcel() {
    const params = {
      exportMode: "xlsx",
      skipHeader: false,
      columnGroups: false,
      skipGroups: false,
      skipFooters: false,
      skipPinnedTop: false,
      skipPinnedBottom: false,
      allColumns: false,
      onlySelected: false,
      onlySelectedAllPages: false,
      fileName: "ApprovableExecutionPlans-" + getExportedExcelFileNameSuffix(),
      sheetName: "Approvable Execution Plans",
      columnKeys: this.gridApi.getAllGridColumns().filter((c) => c.getColDef().colId !== "action"),
    } as ExcelExportParams;

    this.loadingService.setLoading(true);
    this.gridApi.exportDataAsExcel(params);
    this.loadingService.setLoading(false);
  }
}
